module.exports = __webpack_public_path__ + "static/media/foodtruck-min.7bb7a2df.png";